module.exports = __webpack_public_path__ + "static/media/growthsafearea.53b04372.svg";